import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function QuoteForm({ serviceType, defaultServiceOptions = [], contactPerson, contactPhone }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", service_needed: "", location: "",
    preferred_date: "", message: "",
  });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/service-quote", { service_type: serviceType, ...form });
      setDone(true);
      toast.success("Quote request received");
    } catch { toast.error("Something went wrong"); }
    finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="bg-white border border-neutral-200 p-8 text-center" data-testid={`${serviceType}-quote-success`}>
        <h3 className="font-display text-3xl text-[color:var(--hb-navy)]">Thank you for contacting Hampton Blu</h3>
        <p className="mt-4 text-neutral-700">A team member will respond as soon as possible.</p>
        <p className="mt-2 text-sm text-neutral-500">For urgent inquiries, call <b>{contactPerson}</b> at <a href={`tel:${contactPhone.replace(/-/g,'')}`} className="underline">{contactPhone}</a>.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="bg-white border border-neutral-200 p-6 lg:p-8 space-y-4" data-testid={`${serviceType}-quote-form`}>
      <h3 className="font-display text-3xl text-[color:var(--hb-navy)] mb-2">Request a Quote</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <input required placeholder="Your name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="border-b border-neutral-300 py-2" data-testid={`${serviceType}-quote-name`}/>
        <input required type="tel" placeholder="Phone number" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} className="border-b border-neutral-300 py-2" data-testid={`${serviceType}-quote-phone`}/>
        <input required type="email" placeholder="Email address" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="border-b border-neutral-300 py-2 md:col-span-2" data-testid={`${serviceType}-quote-email`}/>
        <select required value={form.service_needed} onChange={e=>setForm({...form,service_needed:e.target.value})} className="border-b border-neutral-300 py-2 bg-transparent" data-testid={`${serviceType}-quote-service`}>
          <option value="">Service needed…</option>
          {defaultServiceOptions.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
        <input required placeholder="Location (city, ZIP)" value={form.location} onChange={e=>setForm({...form,location:e.target.value})} className="border-b border-neutral-300 py-2" data-testid={`${serviceType}-quote-location`}/>
        <input type="date" placeholder="Preferred date" value={form.preferred_date} onChange={e=>setForm({...form,preferred_date:e.target.value})} className="border-b border-neutral-300 py-2 md:col-span-2" data-testid={`${serviceType}-quote-date`}/>
      </div>
      <textarea required rows="4" placeholder="Tell us about your project…" value={form.message} onChange={e=>setForm({...form,message:e.target.value})} className="w-full border border-neutral-200 p-3 text-sm" data-testid={`${serviceType}-quote-message`}/>
      <button disabled={busy} className="hb-btn-primary" data-testid={`${serviceType}-quote-submit`}>{busy ? "Sending…" : "Send Quote Request"}</button>
      <p className="text-xs text-neutral-500 pt-2 border-t border-neutral-100">
        Prefer to speak with someone? Call <b>{contactPerson}</b> at <a href={`tel:${contactPhone.replace(/-/g,'')}`} className="underline">{contactPhone}</a>.
      </p>
    </form>
  );
}
